var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[_vm.$style['mds-icon'], _vm.sizeClass],attrs:{"aria-hidden":"true","data-mds-version":_vm.version,"data-mds-icon-name":_vm.name},domProps:{"innerHTML":_vm._s(_vm.svgIcon)}})}
var staticRenderFns = []

export { render, staticRenderFns }